<template>
    <panel-actions>
        <template #title>{{ lang('pohoda::pohoda.title') }}</template>
        <div class="space-y-2">
            <Button :a="true" color="secondary" type="button" size="sm" :href="exportUrl" class="w-full">
                {{ lang('pohoda::pohoda.actions.single_xml_order_export') }}
            </Button>

            <div v-if="hasOrder" class="text-xs">
                <table class="w-full">
                    <tbody>
                        <tr>
                            <th scope="row" class="text-left font-normal">
                                {{ lang('pohoda::pohoda.fields.pohoda_number') }}
                            </th>
                            <td class="text-right">
                                <strong>{{ orderSyncEntity?.pohoda_number ?? '-' }}</strong>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-left font-normal">
                                {{ lang('pohoda::pohoda.fields.pohoda_id') }}
                            </th>
                            <td class="text-right">
                                <strong>{{ orderSyncEntity?.pohoda_id ?? '-' }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- eslint-disable-next-line vue/no-v-html -->
            <p class="text-xs" v-html="lang('pohoda::pohoda.helps.agenda_orders')"></p>
        </div>

        <div v-if="invoicePdfUrl" class="space-y-2">
            <Button :a="true" color="secondary" type="button" size="sm" :href="invoicePdfUrl" class="w-full">
                Stáhnout PDF fakturu
            </Button>
        </div>

        <div v-if="hasInvoice" class="space-y-2">
            <Button :a="true" color="secondary" type="button" size="sm" :href="invoiceUrl" class="w-full">
                {{ lang('pohoda::pohoda.actions.single_xml_invoice_export') }}
            </Button>

            <div class="text-xs">
                <table class="w-full">
                    <tbody>
                        <tr>
                            <th scope="row" class="text-left font-normal">
                                {{ lang('pohoda::pohoda.fields.pohoda_number') }}
                            </th>
                            <td class="text-right">
                                <strong>{{ invoiceSyncEntity?.pohoda_number ?? '-' }}</strong>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="text-left font-normal">
                                {{ lang('pohoda::pohoda.fields.pohoda_id') }}
                            </th>
                            <td class="text-right">
                                <strong>{{ invoiceSyncEntity?.pohoda_id ?? '-' }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- eslint-disable-next-line vue/no-v-html -->
            <p class="text-xs" v-html="lang('pohoda::pohoda.helps.agenda_invoices')"></p>
        </div>
    </panel-actions>
</template>

<script setup lang="ts">
interface Props {
    orderId: number;
    exportUrl: string;
    invoiceUrl: string | null;
    invoicePdfUrl: string | null;
    isSynced: boolean;
    hasOrder: boolean;
    hasInvoice: boolean;
    orderSyncEntity: {
        pohoda_id: string | null;
        pohoda_number: string | null;
    } | null;
    invoiceSyncEntity: {
        pohoda_id: string | null;
        pohoda_number: string | null;
    } | null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<Props>();
</script>
